export const disasterModeContentStates = [
    "EVENT",
    "CONTEXT",
    "IMMEDIATE_DANGER",
    "DECISION",
    "NEXT_ACTION",
    "CONTINUATION",
    "COMPLETE",
];
export const disasterModeAnswerCatalog = {
    EVENT: ["FICTIONAL_EVENT_A", "FICTIONAL_EVENT_B"],
    CONTEXT: ["CONTEXT_INDOOR", "CONTEXT_OUTDOOR"],
    IMMEDIATE_DANGER: ["DANGER_YES", "DANGER_NO"],
    DECISION: ["BRANCH_ALPHA", "BRANCH_BETA"],
    NEXT_ACTION: ["ACKNOWLEDGE"],
    CONTINUATION: ["CONTINUE", "FINISH"],
    COMPLETE: [],
};
